@if (items && itemTemplate) {
  <div class="slider-wrapper">
    @if (!insufficientItems) {
      @if (inGrid) {
        <div class="slider-container-outer" [ngClass]="containerClass">
          <div class="slider-container">
            <div class="row slider-base-track" #track (touchstart)="dragStart($event)" (mousedown)="dragStart($event)">
              @for (item of items; track `item.id ${$index}`; let index = $index) {
                <div class="slide-item" [ngStyle]="style">
                  <ng-container
                    *ngTemplateOutlet="
                      itemTemplate;
                      context: {
                        index: index,
                        item: item,
                        active: index === activeIndex,
                      }
                    "
                  ></ng-container>
                </div>
              }
            </div>
          </div>
          <div class="prev-arrow-wrapper">
            <span class="arrow-item" (click)="prev()">
              <span class="mb-icon mb-icon-back"></span>
            </span>
          </div>
          <div class="next-arrow-wrapper">
            <span class="arrow-item" (click)="next()">
              <span class="mb-icon mb-icon-forward"></span>
            </span>
          </div>
        </div>
      } @else {
        <div class="slider-base-track" #track (touchstart)="dragStart($event)" (mousedown)="dragStart($event)">
          @for (item of items; track item.id; let index = $index) {
            <div class="slide-item" [ngStyle]="style">
              <ng-container
                *ngTemplateOutlet="
                  itemTemplate;
                  context: {
                    index: index,
                    item: item,
                    active: index === activeIndex,
                  }
                "
              ></ng-container>
            </div>
          }
        </div>
      }
    } @else {
      @if (inGrid) {
        <div [ngClass]="containerClass">
          <div class="row">
            @for (item of originalItems; track item.id; let index = $index) {
              <div class="slide-item insufftpl" [ngStyle]="style">
                <ng-container
                  *ngTemplateOutlet="
                    itemTemplate;
                    context: {
                      index: index,
                      item: item,
                      active: index === activeIndex,
                    }
                  "
                ></ng-container>
              </div>
            }
          </div>
        </div>
      } @else {
        @for (item of originalItems; track item.id; let index = $index) {
          <div class="slide-item" [ngStyle]="style">
            <ng-container
              *ngTemplateOutlet="
                itemTemplate;
                context: {
                  index: index,
                  item: item,
                  active: index === activeIndex,
                }
              "
            ></ng-container>
          </div>
        }
      }
    }
  </div>
  @if (navItems.length > 1) {
    <mb-slider-navigation
      [length]="navItems.length"
      [activeIndex]="activeIndex"
      (indexChange)="slideTo($event)"
      class="navigation"
    ></mb-slider-navigation>
  }
}
